import './styles/index.scss';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import BaseRouter from './router/BaseRouter';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { BaseUrlAuth } from './utils';
function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <BaseRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
